export const PROFILE_REQUEST = 'PROFILE_REQUEST'
export const PROFILE_REQUEST_CUD = 'PROFILE_REQUEST_CUD'
// get
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR'
// create
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR'
